import React from "react"

function IconMediaRecordStopColor({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="media-record-stop-color"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-media-record-stop-color"
      {...props}
    >
      <path
        d="M11.914 1.482c5.76 0 10.431 4.671 10.431 10.432s-4.67 10.432-10.431 10.432c-5.76 0-10.431-4.671-10.431-10.432 0-5.76 4.67-10.432 10.43-10.432zm0 1.31a9.123 9.123 0 1 0 .002 18.245 9.123 9.123 0 0 0-.002-18.246zm2.97 5.093c.568 0 1.028.46 1.028 1.03v5.969c0 .568-.46 1.028-1.028 1.028h-5.97c-.569 0-1.029-.46-1.029-1.028v-5.97c0-.569.46-1.029 1.028-1.029h5.97z"
        fill={color}
        fillRule="nonzero"
        style={{ height: height || fontSize }}
        originalclass="__danger"
      />
    </svg>
  )
}

export default IconMediaRecordStopColor
